export const tableBtnNames = {
  btnAdd: 'btn_add',
  btnEdit: 'btn_edit',
  btnDel: 'btn_del',
  btnImport: 'btn_import',
  btnExport: 'btn_export'
};

export const icons = {
  add: 'plus-round',
  edit: 'edit',
  del: 'trash-b',
  import: 'ios-upload',
  export: 'ios-download',
  default: 'ionic'
};
